import React from "react";
import { useLocation } from "react-router-dom";

export function useQuery(): [URLSearchParams, (key: string, value: string)=> void] {
	const { search } = useLocation();

	const query = React.useMemo(() => new URLSearchParams(search), [search]);
	const setQuery = React.useCallback(
		(key: string, value: string) => {
			query.set(key, value);
		},
		[query]
	);
	return [query, setQuery]
}
